<template>
	<div class="booth-wrap">
		<div class="video-wrap">
			<div class="bar"></div>
			<div class="video-comp">
				<booth-component
					:orientation="orientation"
					:booth-name="booth"
					:controller="links"
					@open-modal="handleModal"
				></booth-component>
			</div>
			<div class="bar"></div>
		</div>
		<!-- <div class="booth-links">
			<h2></h2>
			<div class="group-item" v-for="key in groupKeyArray" :key="key">
				<h3>{{capitalize(key)}}</h3>
				<div class="link" v-for="item in groups[key]" :key="item.code">
					<a v-if="item.type === 'external'" :href="item.link" target="_blank">{{capitalize(item.name)}}</a>
					<a v-if="item.type === 'html-modal'" @click="handleHtmlModal(item)">{{capitalize(item.name)}}</a>
				</div>
			</div>
		</div> -->
	</div>
</template>

<script>
import BoothComponent from "@/components/video/BoothComponent";
import api from "@/api";
export default {
	components: {
		BoothComponent
	},
	props: {
		orientation: Boolean
	},
	data() {
		return {
			links: [],
			groups: {}
		};
	},
	watch: {
		booth: {
			handler () {
				this.getBoothInfo();
			}
		}
	},
	computed: {
		booth() {
			return this.$route.params.booth;
		},
		groupKeyArray() {
			return Object.keys(this.groups);
		}
	},
	mounted() {
		this.getBoothInfo();
	},
	methods: {
		capitalize(str) {
			return str.slice(0, 1).toUpperCase() + str.slice(1);
		},
		async getBoothInfo() {
			try {
                let res = await api.getBoothInfo(this.booth);
				let content = res.data.res;
				let controller = [...content];

				// ***** This loop was used to group content by its group (feature is not used)
                // for (let item of controller) {
                //     if (item.groups) {
				// 		if (!this.groups[item.groups]) {
				// 			this.groups[item.groups] = [];
				// 		}
				// 		this.groups[item.groups].push(item);
				// 	}
                // }


				// for (let itemToModify of this.genericBooth) {
				// 	let item = content.find(el => el.code === itemToModify.code);

        // 	// temp fix so back doenst have to change
        // 	// tldr; if booth is missing brochure but has Website, broch sould route to Website
        // 	if (itemToModify.code === "brochure") {
        // 		let broch = content.find(el => el.code === "brochure");
        // 		let webpage = content.find(el => el.code === "webpage");
        // 		if (!broch && webpage) {
        // 			itemToModify.type = "external";
        // 			itemToModify.link = webpage.text;
        // 			controller.push(itemToModify);
        // 			continue;
        // 		}
        // 	}

        // 	if (!item && !this.defaultTypes.includes(itemToModify.type)) {
        // 		itemToModify.disabled = true;
        // 		controller.push(itemToModify);
        // 		continue;
        // 	}

        // 	if (itemToModify.type === "chat") {
        // 		// console.log(itemToModify);
        // 	}

				// 	if (this.defaultTypes.includes(itemToModify.type)) {
				// 		controller.push(itemToModify);
				// 		continue;
				// 	}
				// 	if (
				// 		item.type === "link" ||
				// 		item.code === "meeting" ||
				// 		item.code === "meeting2"
				// 	) {
				// 		itemToModify.type = "external";
				// 		itemToModify.link = item.text;
				// 	}
				// 	if (item.type === "htm") {
				// 		itemToModify.type = "html-modal";
				// 		itemToModify.con_id = item.con_id;
				// 		itemToModify.booth = this.booth;
				// 	}
				// 	if (item.code === "video") {
				// 		itemToModify.type = "video";
				// 		itemToModify.link = item.text;
				// 	}
				// 	if (item.type === "pdf") {
				// 		itemToModify.type = "external";
				// 		itemToModify.link = `/api/booths/${this.booth}/content/${item.con_id}`;
				// 	}
				// 	controller.push(itemToModify);
				// 	if (item.groups !== null) {
				// 		if (!this.groups[item.groups]) {
				// 			this.groups[item.groups] = [];
				// 		}
				// 		this.groups[item.groups].push(itemToModify);
				// 	}
				// }
				this.groups = Object.assign({}, this.groups);
				this.links = controller;
				api.mixpanel({ event: `clicket_${this.booth}_link` });
				this.postEventTracking({ code: 'enter_booth', data: this.booth })
			} catch (error) {
				this.handleError(error);
			}
		},
		handleModal(link) {
			this.$emit("open-modal", link);
		},
		// used for seems-to-be depricated functionality (booth group)
		// handleHtmlModal(item) {
		// 	this.EventBus.$emit("open-html-modal", {
		// 		src: item
		// 	});
		// }
	},
  async beforeRouteUpdate(to, from, next) {
    let name = to.params.booth;
    let allLocations = await api.getAgendaLocations();
    let loc_id = allLocations.data.result
      .map((el) => {
        if (el.ltp_code === "bth" && el.loc_name == name) return el;
      })
      .filter((el) => el)[0].loc_id;
    if (await api.checkPermission({ loc_id })) next();
    else {
      this.EventBus.$emit("error", this.$t("noPermission"));
      next(from.path);
    }
  },
};
</script>

<style scoped lang="scss">
.booth-wrap {
  overflow: auto;
}
.video-wrap {
  display: flex;
  align-items: center;
}
.video-comp {
  max-height: 100%;
}
.booth-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 15%;
  @media screen and (max-width: 900px) {
    padding: 0 3%;
  }
}
.group-item {
  padding: 20px;
  box-sizing: border-box;
  flex-grow: 1;
  min-width: 300px;
}
h3 {
  background: #4f4f4f;
  color: #fcd07a;
  padding: 10px;
  box-sizing: border-box;
}
a {
  cursor: pointer;
  display: inline-block;
  margin: 15px 0;
  border-bottom: 2px solid #fcd07a;
  transition: border-color 0.2s ease;
  font-size: 1.2rem;
}
a:hover {
  border-color: #4f4f4f;
}
</style>